var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsBookOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 18.6667C1.78301 18.6667 1.31234 18.4906 0.921008 18.1384C0.529674 17.7862 0.333674 17.3623 0.333008 16.8667V2.46675C0.333008 1.97175 0.529008 1.54815 0.921008 1.19595C1.31301 0.843748 1.78367 0.667348 2.33301 0.666748H14.333C14.883 0.666748 15.354 0.843148 15.746 1.19595C16.138 1.54875 16.3337 1.97235 16.333 2.46675V16.8667C16.333 17.3617 16.1373 17.7856 15.746 18.1384C15.3547 18.4912 14.8837 18.6673 14.333 18.6667H2.33301ZM2.33301 16.8667H14.333V2.46675H12.333V8.76675L9.83301 7.41675L7.33301 8.76675V2.46675H2.33301V16.8667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsBookOutline);
export default __webpack_public_path__ + "static/media/material-symbols_book-outline.d5034a447c3d29618338fde9786525b0.svg";
export { ForwardRef as ReactComponent };